<script lang="ts">
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import ConsolidatedCredit from '$lib/components/Simulations/Components/Products/ConsolidatedCredit.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<svelte:head>
	<Title
		content={$__('Simulador de Crédito Consolidado: Consolide as Suas Dívidas Instantaneamente')}
	/>
	<Description
		content={$__(
			'Necessita de simplificar as suas finanças? Utilize o nosso simulador de crédito consolidado para unificar todas as suas dívidas num único pagamento mensal. Rápido, simples e eficaz, o nosso simulador facilita a gestão das suas dívidas e ajuda-o a poupar em juros.'
		)}
	/>
</svelte:head>

<ConsolidatedCredit />
